import RequestBuilder from '../Lib/Requests';

export default class TemplateDashboardService {
  api = new RequestBuilder();

  buildCreateTemplateDashboardRequest(templateID, data, cancelToken) {
    return {
      service: 'gateway',
      endpoint: `/v2/template/${templateID}/dashboard`,
      method: 'post',
      data,
      cancelToken,
    };
  }
  async createTemplateDashboard(templateID, body, cancelToken) {
    const { data = {} } = await this.api.request(
      this.buildCreateTemplateDashboardRequest(templateID, body, cancelToken)
    );
    return data;
  }

  buildFetchAllTemplateDashboardsRequest(templateID, cancelToken) {
    return {
      service: 'gateway',
      endpoint: `/v2/template/${templateID}/dashboard`,
      method: 'get',
      cancelToken,
    };
  }
  async fetchAllTemplateDashboards(templateID, cancelToken) {
    const { data = {} } = await this.api.request(
      this.buildFetchAllTemplateDashboardsRequest(templateID, cancelToken)
    );
    return data;
  }

  buildFetchTemplateDashboardRequest(templateID, dashboardID, cancelToken) {
    return {
      service: 'gateway',
      endpoint: `/v2/template/${templateID}/dashboard/${dashboardID}`,
      method: 'get',
      cancelToken,
    };
  }
  async fetchTemplateDashboard(templateID, dashboardID, cancelToken) {
    const { data = {} } = await this.api.request(
      this.buildFetchTemplateDashboardRequest(
        templateID,
        dashboardID,
        cancelToken
      )
    );
    return data;
  }

  buildUpdateTemplateDashboardRequest(
    templateID,
    dashboardID,
    data,
    cancelToken
  ) {
    return {
      service: 'gateway',
      endpoint: `/v2/template/${templateID}/dashboard/${dashboardID}`,
      method: 'put',
      data,
      cancelToken,
    };
  }
  async updateTemplateDashboard(templateID, dashboardID, body, cancelToken) {
    const { data = {} } = await this.api.request(
      this.buildUpdateTemplateDashboardRequest(
        templateID,
        dashboardID,
        body,
        cancelToken
      )
    );
    return data;
  }

  buildDeleteTemplateDashboardRequest(templateID, dashboardID, cancelToken) {
    return {
      service: 'gateway',
      endpoint: `/v2/template/${templateID}/dashboard/${dashboardID}`,
      method: 'delete',
      cancelToken,
    };
  }
  async deleteTemplateDashboard(templateID, dashboardID, cancelToken) {
    const { data = {} } = await this.api.request(
      this.buildDeleteTemplateDashboardRequest(
        templateID,
        dashboardID,
        cancelToken
      )
    );
    return data;
  }

  buildCreateTemplateDashboardWidgetRequest(
    templateID,
    dashboardID,
    data,
    cancelToken
  ) {
    return {
      service: 'gateway',
      endpoint: `/v2/template/${templateID}/dashboard/${dashboardID}/widget`,
      method: 'post',
      data,
      cancelToken,
    };
  }
  async createTemplateDashboardWidget(
    templateID,
    dashboardID,
    body,
    cancelToken
  ) {
    const { data = {} } = await this.api.request(
      this.buildCreateTemplateDashboardWidgetRequest(
        templateID,
        dashboardID,
        body,
        cancelToken
      )
    );
    return data;
  }

  buildUpdateTemplateDashboardWidgetRequest(
    templateID,
    dashboardID,
    widgetID,
    data,
    cancelToken
  ) {
    return {
      service: 'gateway',
      endpoint: `/v2/template/${templateID}/dashboard/${dashboardID}/widget/${widgetID}`,
      method: 'put',
      data,
      cancelToken,
    };
  }
  async updateTemplateDashboardWidget(
    templateID,
    dashboardID,
    widgetID,
    body,
    cancelToken
  ) {
    const { data = {} } = await this.api.request(
      this.buildUpdateTemplateDashboardWidgetRequest(
        templateID,
        dashboardID,
        widgetID,
        body,
        cancelToken
      )
    );
    return data;
  }

  buildDeleteTemplateDashboardWidgetRequest(
    templateID,
    dashboardID,
    widgetID,
    cancelToken
  ) {
    return {
      service: 'gateway',
      endpoint: `/v2/template/${templateID}/dashboard/${dashboardID}/widget/${widgetID}`,
      method: 'delete',
      cancelToken,
    };
  }
  async deleteTemplateDashboardWidget(
    templateID,
    dashboardID,
    widgetID,
    cancelToken
  ) {
    const { data = {} } = await this.api.request(
      this.buildDeleteTemplateDashboardWidgetRequest(
        templateID,
        dashboardID,
        widgetID,
        cancelToken
      )
    );
    return data;
  }

  buildSetUserDefaultDashboardRequest(gatewayID, data, cancelToken) {
    return {
      service: 'gateway',
      endpoint: `/v2/gateway/${gatewayID}/dashboard`,
      method: 'post',
      data,
      cancelToken,
    };
  }
  async setUserDefaultDashboard(gatewayID, body, cancelToken) {
    const { data = {} } = await this.api.request(
      this.buildSetUserDefaultDashboardRequest(gatewayID, body, cancelToken)
    );
    return data;
  }

  buildCheckUserPreferenceDashboardRequest(
    gatewayID,
    dashboardID,
    cancelToken
  ) {
    return {
      service: 'gateway',
      endpoint: `/v2/gateway/${gatewayID}/dashboard/${dashboardID}/isUserPreference`,
      method: 'get',
      cancelToken,
    };
  }
  async checkUserPreferenceDashboard(gatewayID, dashboardID, cancelToken) {
    return this.api.request(
      this.buildCheckUserPreferenceDashboardRequest(
        gatewayID,
        dashboardID,
        cancelToken
      )
    );
  }
}
